var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"favorite-group-items"},[_c('div',{staticClass:"favorite-group-items__list"},[_vm._l((_vm.tabs),function(tab,index){return [(tab.is_visible)?_c('NavigationCard',{key:`favorite-item-${index}`,attrs:{"tab":tab,"hideDescription":true}}):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }